
class BlogSource {
    constructor(API) {
        this.API = API;
    }

     async getList(data) {
         return await this.API.get('/index.php?route=api/blog', {
             params: data
         })
     }


    async getArticle(data) {
        return await this.API.get('/index.php?route=api/blog/article', {
            params: data
        })
    }


}

export default BlogSource
